export const formatSearchParam = (key: string, searchParam: string | null) => {

    if (searchParam == null || searchParam === "") {
        return `?${key}=1002`;
    }

    return `?${key}=${searchParam}`;
};
